var map = {
	"./elephant_ui_disappointed": 1293,
	"./elephant_ui_disappointed.svg": 1293,
	"./elephant_ui_working": 1093,
	"./elephant_ui_working.svg": 1093,
	"./glitch-preview": 1294,
	"./glitch-preview.jpg": 1294,
	"./logo_warn_glitch": 1024,
	"./logo_warn_glitch.svg": 1024,
	"./mbstobon-ui-0": 1295,
	"./mbstobon-ui-0.png": 1295,
	"./mbstobon-ui-1": 1296,
	"./mbstobon-ui-1.png": 1296,
	"./mbstobon-ui-2": 1297,
	"./mbstobon-ui-2.png": 1297,
	"./mbstobon-ui-3": 1298,
	"./mbstobon-ui-3.png": 1298,
	"./wave-drawer": 1299,
	"./wave-drawer-glitched": 1300,
	"./wave-drawer-glitched.png": 1300,
	"./wave-drawer.png": 1299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1352;